// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__vM2kz","active":"downloadDropdown_active__27UKU"};